<script>
import Vue from "vue";
import store from "@/state/store";
import VTooltip from "v-tooltip";
import Swal from "sweetalert2";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrProsesGiris from "@/models/StrProsesGiris";
import KanitGiris from "../StrProsesKanit/AddEdit.vue";
import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrProsesGiris],
  props: ["BirimId", "DonemId", "Sorgulama", "Onayid", "Universite"],
  components: {
    KanitGiris
  },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Prosesler: [],
      TabloDetayVerileri: [],
      Basliklar: [],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      ilk_deger: [],
      Kanit_BirimId: "",
      Kanit_DonemId: "",
      Kanit_TabloId: "",
      Proses_Kanitlar: "",
      Aciklama_Veri: "",
      deger: "",
      aciklama: "",
      sayac: 0,
      kontrol: 0,
      bugun: null,
      GostergeData: [],
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
  },

  methods: {
    kaydet(veri) {
      if (veri.Deger != this.ilk_deger) {
        if (veri.Deger != null) {
          this.$delete(veri, "DonemAdi");
          this.$delete(veri, "Onay");

          if (
            veri.Id == "00000000-0000-0000-0000-000000000000" ||
            veri.id == ""
          ) {
            this.$delete(veri, "Id");

            this.ProsesPost("StrProsesGiris", veri);
          } else {
            this.ProsesUpdate("StrProsesGiris", veri);
          }
        } else {
          if (veri.Aciklama != null) {
            this.$toast.error(this.$t("Lütfen öncelikle bir değer giriniz!"));
          } else {
            this.$toast.error(this.$t("Lütfen geçerli bir değer giriniz!"));
          }

        }
      }
    },

    async ProsesPost(Servis, Data, Mesaj) {
      return this.ActionsPost({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.PostPozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            //this.Get();
            return res;
          } else {
            let hata_mesaji = "";

            if (res.Message != null) {
              hata_mesaji = this.$t("ToasMessage.PostNegatif") + " \n" + res.Message;
            } else {
              hata_mesaji = this.$t("ToasMessage.PostNegatif");
            }

            this.$toast.error(hata_mesaji);

            return res;
          }
        }
      );
    },
    async ProsesUpdate(Servis, Data, Mesaj) {
      return this.ActionsPut({ Service: Servis, Data: Data }).then((res) => {
        if (res.Succeeded == true) {
          if (Mesaj != false) {
            if (Mesaj === undefined || Mesaj === null) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.success(Mesaj);
            }
          }
          // this.Get();
          return true;
        } else {
          //this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));



          let hata_mesaji = this.$t("ToasMessage.PostNegatif");
          if (res.errors.length > 0) {
            hata_mesaji = "";
            for (var i = 0; i < res.errors.length; i++) {
              hata_mesaji = hata_mesaji + "\n" + res.errors[i];
            }

          }
          this.$toast.error(hata_mesaji);


          return false;
        }
      });
    },

    Kanit_yukle() {  // Kanıt girildi girilmedi kontrolü için

      let Filter = "&BirimId=" + this.BirimId + "&UstDonemId=" + this.DonemId;

      this.ActionsFilterGet({ Service: "StrProsesKanit", Page: this.Page, Filter: Filter }).then((res) => {

        this.Proses_Kanitlar = res.Data;


      });
    },

    kanit_kontrol(Donemid, Birimid, Tabloid) {

      let Filter = this.Proses_Kanitlar.filter((notification) =>
        notification.Donemid.includes(Donemid)
      );
      Filter = Filter.filter((notification) =>
        notification.Birimid.includes(Birimid)
      );

      Filter = Filter.filter((notification) =>
        notification.Tabloid.includes(Tabloid)
      );

      let VeriUzunlugu = Filter.length;

      return VeriUzunlugu;


    },


    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.$delete(this.FormData, "Id");
          this.Post("StrProsesGiris", this.FormData);
        } else {
          this.Update("StrProsesGiris", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
            }
          });
        }
      }
    },

    Get() {
      this.bugun = new Date();
      //alert(this.bugun);
      this.Prosesler = [];
      this.TabloDetayVerileri = [];
      this.Basliklar = [];

      this.Kanit_yukle();

      let Filter = "&BirimId=" + this.BirimId + "&UstDonemId=" + this.DonemId;

      this.ActionsFilterGet({
        Service: "StrProsesGiris",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.Prosesler = res.Data;
        this.GostergeData = [];
        for(var Proses in this.Prosesler){
          for(var ProsesDetay in this.Prosesler[Proses].TabloDetay){
          if(this.Prosesler[Proses].TabloDetay[ProsesDetay].Detay.Seviye == 3){
            for(var GirisData in this.Prosesler[Proses].TabloDetay[ProsesDetay].Giris){
             this.GostergeData.push(this.Prosesler[Proses].TabloDetay[ProsesDetay].Giris[GirisData])
            }
          }

        }

        }

        this.Page.PageDataSize = res.TotalCount;


        this.$emit("yuklendi", 1);

      });
    },
    DonemOnayDurum(Donemid){
      for(var Data in this.GostergeData){
        if(this.GostergeData[Data].Donemid == Donemid){
          
          if(this.GostergeData[Data].Onay == true){

            return true
          }else{
            return false
          }
        }
      }

    },
    DonemOnayla(DonemId, BirimId, UstId) {
      Swal.fire({
        title: "Veri Kontrolü",
        text:
          "Burada Yer alan verilerin güvenilir, Tam ve Doğru olduğunu beyan ederim",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Onayla",
        cancelButtonText: "Vazgeç",
      }).then((result) => {
        if (result.value) {


          let onaylanacak = { "Ustdonemid": UstId, "Donemid": DonemId, "Birimid": BirimId, "Onay": true };


          this.AllUpdate("StrProsesGiris/UpdateDonemOnay", onaylanacak).then((res) => {


            if (res == true) {

              /*
              this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = res.Message;
                this.Message.showConfirmButton = false;
                this.Message.timer = 1000;

                Vue.swal(this.Message);
                */


              this.sayac++;
              this.$emit("Guncelle", this.sayac);

            } else {
              this.Message.html = "";
              this.Message.position = "center";
              this.Message.icon = "warning";
              this.Message.title = res.Message;
              this.Message.showConfirmButton = false;
              this.Message.timer = 100000;

              Vue.swal(this.Message);

            }

          });



        }
      });




    },
    getColorCode(code) {
      if (code === 1) {
        return '#b3e0ff';
      } else if (code === 2) {
        return '#cce5ff';
      } else if (code === 3) {
        return '#e5f2ff';
      } else {
        return '';
      }
    },
    DonemIptal(DonemId, BirimId) {
      Swal.fire({
        title: "Dikkat",
        text: "Dönem Onayı İptal Edilecek Eminmisiniz?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Onay İptal",
        cancelButtonText: "Vazgeç",
      }).then((result) => {

        if (result.value) {

          let onaylanacak = { BirimId: BirimId, DonemId: DonemId, Onay: false };
          this.AllUpdate("StrProsesGiris/UpdateDonemOnay", onaylanacak).then(
            () => {

              this.sayac++;
              this.$emit("Guncelle", this.sayac);

            }
          );

        }

      });


      this.sayac++;
      this.$emit("Guncelle", this.sayac);

    },

    yetki_kontrol(yetki) {

      var sonuc = this.KullaniciBilgileri.indexOf(yetki);

      return sonuc;

    },


  },
  computed: {},

  created() {
    this.KullaniciBilgileri = store.getters["auth/UserRolles"];
    this.Get();

  },
};
</script>
<template>
  <div>

    <div class="table-responsive">

      <template v-for="(Proses, index) in Prosesler">

        <table :key="index" class="table table-striped">
          <tbody>
            <tr>
              <th style="font-weight: bold;">Prosesin Adı</th>
              <th style="font-weight: bold;">{{ Proses.Prosesadi }}</th>
            </tr>
            <tr>
              <td colspan="2">

                <table>
                  <tbody style="margin-top: 5px;">
                    <tr>
                      <td class="py-4" style="text-align: center; font-weight: bold;">Sıra No</td>
                      <td style="font-weight: bold;">Hedef / Eylem / Gösterge</td>
                      <td style="font-weight: bold;" v-for="donem in Proses.TabloDetay[0].Giris" :key="donem.Donemid">
                        <center>
                          {{ donem.Donemadi }}
                          <br>

                          <div
                            v-if="(yetki_kontrol('StrAdmin') >= 0 || yetki_kontrol('SuperAdmin') >= 0) && index == 0">
                            <div v-if="!DonemOnayDurum(donem.Donemid)">


                              <button class="btn btn-success btn-label" type="button" @click="
                                DonemOnayla(
                                  donem.Donemid,
                                  donem.Birimid,
                                  DonemId
                                )
                                " v-tooltip="$t('StrProsesGiris.Table.BtnOnay')">
                                <i class="bx bx-check-double label-icon"></i> </button>


                            </div>
                            <div v-else>

                              <button class="btn btn-danger btn-label" type="button" @click="
        DonemIptal(
          donem.Donemid,
          donem.Birimid

        )
        " v-tooltip="$t('StrPerfRaporGiris.Table.Btniptal')">
                                <i class="bx bx-x label-icon"></i> </button>


                            </div>
                          </div>

                        </center>

                      </td>

                    </tr>

                    <tr v-for="tablo in Proses.TabloDetay" :key="tablo.Prosesid"
                      :style="{ backgroundColor: getColorCode(tablo.Detay.Seviye), color: 'black' }">
                      <td class="py-4" style="width:7%; text-align: center;">{{ tablo.Detay.Sirano }}</td>
                      <td style="width:43%">{{ tablo.Detay.Tabloadi }}</td>
                      <td v-for="veri in tablo.Giris" :key="veri.Id" class="py-2">
                        <center>
                          <input v-if="tablo.Detay.Seviye == 3 && (new Date(veri.BaslamaTarihi) < bugun &&
        new Date(veri.BitisTarihi) > bugun) &&
        (veri.Onay == false || veri.Onay == null || veri.Onay == '')" id="number"
                            v-on:input="(veri.Deger = $event.target.value)" v-bind:value="veri.Deger" @keyup.enter="
        enterla - exit - birlikte - calisiyor
        " @blur="kaydet(veri)" @focus="ilk_deger = veri.Deger" name="number" type="number" style="margin-bottom:5px;"
                            class="form-control" />



                          <span v-if="veri.Onay == true && tablo.Detay.Seviye == 3"> {{ veri.Deger }} </span>

                          <span v-if="tablo.Detay.Seviye == 3">

                            <span v-if="kanit_kontrol(veri.Donemid, veri.Birimid, veri.Tabloid) == 1">

                              <i style="font-size: 20px; color:blue; margin-right:15px"
                                class="mdi mdi-clipboard-edit-outline me-1" v-tooltip="$t('StrProsesGiris.tooltip.KanitGerekli')
        " @click="Kanit_DonemId = veri.Donemid, Kanit_BirimId = veri.Birimid, Kanit_TabloId = veri.Tabloid"
                                v-b-modal.StrProsesKanit>
                              </i>
                            </span>

                            <span v-else>

                              <i style="font-size: 20px;  margin-right:15px" class="mdi mdi-clipboard-edit-outline me-1"
                                v-tooltip="$t('StrProsesGiris.tooltip.KanitGerekli')
        " @click="Kanit_DonemId = veri.Donemid, Kanit_BirimId = veri.Birimid, Kanit_TabloId = veri.Tabloid"
                                v-b-modal.StrProsesKanit>
                              </i>
                            </span>
                            <span>

                              <i style="font-size: 20px;  margin-right:15px" class="mdi mdi-comment-plus-outline me-1"
                                v-tooltip="$t('StrProsesGiris.tooltip.Aciklama')
        " @click="Aciklama_Veri = veri" v-b-modal.StrProsesAciklama>
                              </i>
                            </span>

                          </span>
                        </center>

                      </td>

                    </tr>


                  </tbody>
                </table>


              </td>
            </tr>
          </tbody>


        </table>

      </template>

    </div>

    <KanitGiris :Kanit_DonemId="Kanit_DonemId" :Kanit_BirimId="Kanit_BirimId" :Kanit_TabloId="Kanit_TabloId"
      @Guncelle="Kanit_yukle()" />

    <b-modal v-if="Aciklama_Veri" id="StrProsesAciklama" size="lg" title-class="font-18" hide-footer>
      <textarea id="StrProsesAciklama" name="aciklama" v-model="Aciklama_Veri.Aciklama" maxlength="4000" rows="12"
        placeholder="" class="form-control">
  </textarea>
      <br>

      <button v-if="(new Date(Aciklama_Veri.BaslamaTarihi) < bugun &&
        new Date(Aciklama_Veri.BitisTarihi) > bugun)" class="btn btn-primary" @click="kaydet(Aciklama_Veri)"
        type="button">Kaydet</button>
    </b-modal>

  </div>
</template>
